import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { apiUrl } from "../../global/global";
import swal from "sweetalert2";
import { AdminService } from "../../services/admin.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Router, ActivatedRoute } from "@angular/router";
import { ImageUrls } from "src/app/services/s3buket";
import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { FormGroup, FormBuilder } from "@angular/forms";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { DeleteAccountService } from "./delete-account-password/service/delete-account.service";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.css"],
})
export class SettingsComponent implements OnInit {
  fileUpload;
  dummyImage:any;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users;
  modalRef?: BsModalRef;
  showError = false;
  userData;
  profileForm: FormGroup;
  editMode = false;
  // cropper
  image;
  profileImageUpload;
  imageUpload;
  show: boolean = false;
  showErrorPhoneNo: boolean = false;
  loader = false;
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  @Input() objectProperty: any;
  @Output() valueChange = new EventEmitter();
  objectProp: any;
  constructor(private modalService: BsModalService, private formBuilder: FormBuilder, public route: ActivatedRoute,  private router: Router, private api: AdminService, private toastrService: ToastrService,
    private http: HttpClient, private handler: HttpBackend, private userDetailsService: UserDetailsService, private deleteAccountService: DeleteAccountService) {
    this.profileForm = this.formBuilder.group({
      profileImage: [""],
      name: [""],
      email: [""],
    })
  }

  ngOnInit(): void {
    this.getUserDetail();
    this.editMode = false;
    this.profileForm.controls["email"].disable();
  }

  getUserDetail() {
    this.api.getDatas(apiUrl._getUserInfo)
      .subscribe(async (res) => {
        this.userData = res.data;
        this.imageUpload = res.data.profileImage;
        if (this.userData.profileImage != null) {
          this.dummyImage = this.globalUrl + res.data.profileImage
        }
        this.profileForm.patchValue(res.data)
      })
  }

  // image upload
  // upload(event) {
  //   const files = event.target.files;

  //   this.fileUpload = files[0];
  //   this.uploadFileToS3();
  // }

  // uploadFileToS3() {
  //   const data = {
  //     "directory": ImageUrls.directories.users,
  //     "fileName": this.fileUpload.name,
  //     "contentType": this.fileUpload.type
  //   }
  //   this.api.postData(apiUrl._upload, data)
  //     .subscribe(res => {
  //       this.http = new HttpClient(this.handler);
  //       this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
  //         this.profileForm.value.profileImage = res.data.fileName;
  //         this.dummyImage = this.globalUrl + res.data.fileName;
  //         this.profileForm.patchValue({
  //           profileImage: res.data.fileName
  //         })

  //       })
  //     })
  // }

  upload(event) { 
    if (event.target.files.length == 0) {
      return
    }
    if (event.target.files[0].type.includes("image") && event.target.files[0].name.split(".")[1] !="jfif") {
      this.show = true;
      this.loader = true;
      this.objectProp = { "event": event, "directory": "users/", "imagewidthsize": false, "imageheightsize": false, "aspectRatio": 1 / 1, "roundCropper": false,"maintainAspectRatio" : true,"typeCropper": 1, "cropperHeight" : 500, "cropperMinWidth" : 500,"showOnlySquare" : true };
    } else{
      this.toastrService.error("Please upload only Jpg,Jpeg & Png images!");
      this.show = false;
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 5000);      
    }
  }
  catchFile(event) {  
    this.show = false; 
    if(event.image1 != "" && event.file !=""){
      this.profileImageUpload = event.image1;
      this.imageUpload=  event.file;
      this.show = false;
      this.profileForm.patchValue({
        profileImage:this.imageUpload
      })
      this.api.loader(false)
      
    }  
  }   
  onFileUploaded(rawImage, fileName) { 
  }
   
  onChangeDetected(event) {
  }
  close(){
    this.show = false;
  } 
  editName() {
    this.editMode = true;
  }
  // submit from
  onSubmit() {
    if (this.profileForm.valid) {
      this.api.putData(apiUrl._updateProfile, this.removeEmptyFiled(this.profileForm))
        .subscribe(async (res) => {
          this.editMode = false;
          this.userDetailsService.getUserData();
        })
    } else {
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 3000);
    }
  }
  //remove

  removeEmptyFiled(form) {
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
  //  delete
  deleteAccount(event) {

    if (this.userDetailsService.userDetails.loginType == 1) {
      this.router.navigate(['/settings/delete-account-password'])
    }
    else {
      this.deleteAccountService.deleteAccountConfirmation({}); 
    }
  }
  // change password
  toRedirect() {
    this.api.putDataWihtoutParam(apiUrl._otpResend)
      .subscribe(async (res) => {
        this.toastrService.success("OTP send successfully on your Register Email.");
        this.router.navigate(["/settings/verify"]);
      }, err => {
        this.toastrService.error("Error", err.error.message)
      })
  }  
}